import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const TEAM_REQUEST = 'FETCH_TEAM_REQUEST';
export const TEAM_FAILURE = 'FETCH_TEAM_FAILURE';
export const TEAM_SUCCESS = 'FETCH_TEAM_SUCCESS';

/**
 * @param {string} [competition] narrows the read to ONE competition's teams —
 *   45 KB against 537 KB, measured on live data (1 Oct 2026). Both screens
 *   that read this slice, `/applications` and `/competitions`, already discard
 *   every other competition's teams client-side.
 *
 *   Omit it for the whole collection; the store then records `fetchedCompetition
 *   = null`, which is what tells a later reader the list is complete.
 *
 *   The narrowing lives in `TeamCollectionDataProvider`, not in an
 *   `@ApiFilter`: that provider replaces API Platform's Doctrine one, so an
 *   annotation would be accepted and ignored.
 */
export const fetchTeams = (competition = null) => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.TEAM.LIST, competition ? { competition } : null))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data, competition)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return {
        type: TEAM_REQUEST,
    }
};

const fetchFailure = (error) => {
    return {
        type: TEAM_FAILURE,
        error,
    }
};

const fetchSuccess = (data, competition = null) => {
    return {
        type: TEAM_SUCCESS,
        data,
        competition,
    }
};